"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationBellIcon = void 0;
var ToggleMenuFlyoutEvent = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NotificationBellIcon = () => {
  const [ref, Icon] = (0, _hooks.useHover)(_icons.NotificationFilled, _icons.Notification);
  const [isClicked, setIsClicked] = (0, _react.useState)(false);
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    data
  } = (0, _globalApiClientReact.useGetCustomerUnseenNotificationsCount)(customerId, {
    [_fetching.CLIENT_APPLICATION]: 'Web' /* notifications API requires value `Web` */
  }, {
    swr: (0, _presentationUtils.getRetryErrorSwrOptions)()
  });
  const {
    count
  } = data ?? {
    count: 0
  };
  const handleClick = (0, _react.useCallback)(() => {
    UserAction.dispatch(_constants.CLICK_NOTIFICATION_ICON);
    setIsClicked(true);
    (0, _utils.dispatchToggleMenu)(ToggleMenuFlyoutEvent.MenuTypes.Notifications);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NotificationBellIconButton, {
    ref: ref,
    variant: "text",
    "aria-label": translations.notifications,
    "data-testid": getTestId(_constants2.NOTIFICATION_BELL_ICON_BUTTON),
    onClick: handleClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Badge, {
      color: "error",
      badgeContent: count,
      max: 99,
      "data-testid": getTestId(_constants2.NOTIFICATION_BELL_ICON_BELL),
      invisible: isClicked || count === 0,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        fontSize: "inherit"
      })
    })
  });
};
exports.NotificationBellIcon = NotificationBellIcon;
